export var VELT_SDK_VERSION = '4.5.5';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.5': 'sha384-dq5YFJ60mO0hOnwFX5o8HUtgXy5z10aenHVjtSpJEgpZJm9vOR4vQ0UCTzZ5H6s6',
};
